// extracted by mini-css-extract-plugin
export default {"dashboardCardItem":"DashboardCard_dashboardCardItem__zZ8T-"};